import React from 'react';
import config from 'react-global-configuration';

import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import LogoImageVNL from '../../assets/images/VNL_logo.svg';
import LogoImageVNLWhite from '../../assets/images/VNL_logo_white.svg';
import LogoImageKVNL from '../../assets/images/kvnl-logo-subtitle.svg';
import { DOMAIN_KVNL } from '../../config/constants';

import './style.scss';

const Logo = ({ url, footer = false }) => {
  let logo = LogoImageVNL;

  if (config.get('CURRENT_DOMAIN') === DOMAIN_KVNL) {
    logo = !footer ? LogoImageKVNL : LogoImageVNLWhite;
  }

  return (
    <div className="LogoWrapper">
      <CoreLink className="Logo" href={url}>
        <img src={logo} alt="VeiligheidNL" />
      </CoreLink>
    </div>
  );
};

// Set default props
Logo.defaultProps = {
  url: '/',
};

export default Logo;

